import React from "react";
import { default as MultiSelect } from "components/Input/MultiSelect";
import Select from "components/Input/Select";
import Checkbox from "components/Input/Checkbox";
import Button from "components/Button";
import classes from "./styles.module.scss";

import Export from "assets/images/icons/JSX/Export";

const Filters = ({
    allModels = [],
    selectedModels = [],
    setSelectedModels = () => {},
    aggregatedUnitSystem = "imperial",
    setAggregatedUnitSystem = () => {},
    applyModelResultMultiplier = false,
    setApplyModelResultMultiplier = () => {},
    handleExportCSV = () => {},
}) => {
    return (
        <div className={classes.filtersContainer}>
            <div className={classes.filterWrapper}>
                <div className={classes.filterLabel}>Model:</div>
                <MultiSelect
                    idPrefix="results-aggregated-models"
                    className={classes.filterSelect}
                    options={allModels.sort((a, b) => a.label.localeCompare(b.label))}
                    input={{
                        value: selectedModels,
                        onChange: setSelectedModels,
                    }}
                    dropdownStyles={{ top: "2rem", width: "167px", zIndex: 100 }}
                    hasSelectAll={true}
                    forcedLabel={
                        selectedModels.length === allModels.length ? "All Models" : `${selectedModels.length} Selected`
                    }
                />
            </div>
            <div className={classes.filterWrapper}>
                <div className={classes.filterLabel}>Units:</div>
                <Select
                    className={classes.filterSelectUnit}
                    options={[
                        { label: "Imperial", value: "imperial" },
                        { label: "Metric", value: "metric" },
                    ]}
                    input={{
                        value: aggregatedUnitSystem,
                        onChange: setAggregatedUnitSystem,
                    }}
                />
            </div>
            <div className={classes.filterWrapper}>
                <Checkbox
                    label="Include Duplicates"
                    input={{
                        value: applyModelResultMultiplier,
                        onChange: setApplyModelResultMultiplier,
                    }}
                    large
                />
            </div>
            <div className={classes.filterWrapper} style={{ marginLeft: "auto" }}>
                <Button smallPadding onClick={handleExportCSV} icon={() => <Export fill="#fff" />}>
                    Export Data
                </Button>
            </div>
        </div>
    );
};

export default Filters;
